<script>
  import { currentLang } from "stores.js";

  import Divider from "components/Divider.svelte";
  import RichText from "components/RichText.svelte";
  import Program from "../events/Program.svelte";
  import RegistrationButton from "../events/RegistrationButton.svelte";

  export let workshop;
  export let registrations;

  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
</script>

<div class="wrapper">
  <h2 class="title">{workshop.title[$currentLang] || ""}</h2>
  {#if workshop.date}
    <p class="date">
      {new Date(workshop.date).toLocaleDateString($currentLang, options)}
    </p>
  {/if}
  {#if workshop.teaser && workshop.teaser[$currentLang]}
    <div class="teaser">
      <RichText content={workshop.teaser[$currentLang]} />
    </div>
  {/if}
  <Program programs={workshop.program} />

  <RegistrationButton
    event={workshop}
    {registrations}
    on:unregister
    on:register
    on:loginAndRegister
  />
  <Divider />
</div>

<style>
  .wrapper {
    margin: 96px 0;
  }

  .title {
    margin: 0 auto;
    font-weight: 200;
    text-transform: uppercase;
    letter-spacing: 0.03rem;
    text-align: center;
    max-width: 300px;
  }

  .date {
    margin: 0;
    text-align: center;
    font-weight: 600;
  }

  @media only screen and (min-width: 600px) {
    .title {
      font-size: 33px;
      max-width: 960px;
    }
    .date {
      font-size: 18px;
    }
  }

  .teaser {
    margin-top: 48px;
  }
</style>
